import { React, useState } from 'react'
import Header from '../Header/Header.js'
import SideBar from '../OrderPage/SideBar.js'
import SettingsHeader from '../OrderPage/SettingsHeader.js'
import { GiSettingsKnobs } from 'react-icons/gi'
// import { useState } from "react";
import { FaTag } from "react-icons/fa";

const LabelSetting = () => {
    const [selectedLabel, setSelectedLabel] = useState("thermal");
    return (
        <>

            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar
                />

                {/* Main Content */}
                <div className="flex-1 space-y-6 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <SettingsHeader />
                    <div className="grid grid-cols-12 md:space-x-7 min-h-screen">
                        {/* Sidebar (Left Panel) */}
                        <div className="col-span-3 bg-white p-6 rounded-md hidden md:block">
                            {/* Content for sidebar */}
                            <h1 className='font-semibold text-xl mb-6'>Settings</h1>
                            <p>Take your shipping experience a notch higher with us by regulating your panel settings as per your convenience and specific business requirements. From importing orders to managing labels and all other account settings, get everything at the tap of your finger for an uninterrupted experience.</p>
                            <GiSettingsKnobs className="h-96 w-96 text-slate-100" />
                        </div>

                        {/* Main Content (Right Panel) */}
                        <div className="col-span-12 md:col-span-9 rounded-md bg-white p-4">
                            <div className="px-4 py-2 mb-7 flex items-center space-x-3 border border-sky-100 bg-sky-50">
                                <FaTag />
                                <h2>Label Setting</h2>
                            </div>
                            {/* <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg"> */}
                            {/* Title */}

                            {/* Subtitle */}
                            <p className="text-gray-600 font-medium text-sm mb-4">Set your shipping label format</p>

                            {/* Label Options */}
                            <div className="grid grid-cols-1 text-sm md:grid-cols-2 gap-4">
                                {/* Disabled Option */}
                                <label
                                    className={`flex items-center w-full p-4 border rounded-lg cursor-not-allowed bg-slate-200 border-slate-300 opacity-75`}
                                >
                                    <input type="radio" name="labelFormat" className="hidden" disabled />
                                    <span className="w-5 h-5 flex items-center justify-center border-2 rounded-full mr-3 border-slate-400 bg-slate-300"></span>
                                    <span className="text-slate-800 font-medium">Standard Desktop Printers - Size A4 (8"X11")</span>
                                </label>

                                {/* Active Option */}
                                <label
                                    className={`flex items-center w-full p-4 border rounded-lg cursor-pointer transition-all ${selectedLabel === "thermal" ? "bg-sky-100" : "bg-gray-100 border-gray-300"
                                        }`}
                                    onClick={() => setSelectedLabel("thermal")}
                                >
                                    <input
                                        type="radio"
                                        name="labelFormat"
                                        className="hidden"
                                        checked={selectedLabel === "thermal"}
                                        onChange={() => setSelectedLabel("thermal")}
                                    />
                                    <span
                                        className={`w-5 h-5 flex items-center justify-center border-2 rounded-full mr-3 transition-all ${selectedLabel === "thermal" ? "border-slate-700 bg-slate-600" : "border-gray-400 bg-white"
                                            }`}
                                    >
                                        {selectedLabel === "thermal" && <span className="w-2.5 h-2.5 bg-white rounded-full"></span>}
                                    </span>
                                    <span className="text-gray-800 font-medium">Thermal Label Printers - Size (4"X6")</span>
                                </label>
                            </div>

                            {/* Submit Button */}
                            <div className="mt-6">
                                <button
                                    className="w-full md:w-auto px-6 py-2 text-sm bg-slate-800 text-white font-semibold rounded-lg hover:bg-slate-800 transition-all"
                                >
                                    Submit
                                </button>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>



                </div>

            </div >
        </>
    )
}

export default LabelSetting
